import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-2023"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M13.935 6.893 10.74 1.667a.256.256 0 0 0-.438 0L7.107 6.893a.257.257 0 0 0 .22.391h6.389c.2 0 .323-.22.219-.391zm-3.414-.784a.292.292 0 1 1 0-.585.292.292 0 0 1 0 .585zm.198-.85h-.396l-.162-1.157a.363.363 0 1 1 .72 0l-.162 1.157zm-2.111 7.314 6.353-1.631-11.186-2.39 2.459 2.078L0 12.292l9.089 3.481L16 14.474z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }